import { render, staticRenderFns } from "./ProjectViewDashboard.vue?vue&type=template&id=d41ee97e&scoped=true&"
import script from "./ProjectViewDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectViewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewDashboard.vue?vue&type=style&index=0&id=d41ee97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41ee97e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VImg,VRow,VSpacer})
